import { createEntityAdapter } from '@reduxjs/toolkit';

import type { TMessage } from '~entities/messages';

export const messagesAdapter = createEntityAdapter({
	selectId: (item: TMessage) => (item ? item.tag : ''),
});

export const messagesSelector = messagesAdapter.getSelectors();
